<template>
  <div>
    <search-agents-esim-product @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showImportModal"
          v-if="isShowMenu('agents_esim_products/import')"
        >导入eSIM</a-button>

        <update-agents-esim-product-effective
          v-if="isShowMenu('agents_esim_products/effective')"
          :selected-row-keys="selectedRowKeys"
          @completed="fetchData"
        />
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            操作 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="isHasEditPermission">
              <a @click="showEditModal(record.id)">编辑</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="showOperationHistoryModal(record.id)">操作历史</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <import-agents-esim-product
      v-if="isShowImportModal"
      :agent-id="agentId"
      :visible.sync="isShowImportModal"
      @completed="fetchData"
    />

    <edit-agents-esim-product
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :id="editingId"
      @completed="fetchData"
    />

    <operation-history-list-modal
      v-if="isShowOperationHistoryModal"
      :reference-id="showingOperationHistoryId"
      reference-type="AgentsEsimProduct"
      :visible.sync="isShowOperationHistoryModal"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findAgentsEsimProducts } from '@/api/agents_esim_product'
import Pagination from '@/components/Pagination'
import SearchAgentsEsimProduct from '@/views/agents_esim_products/Search'

export default {
  name: 'AgentsEsimProductList',
  components: {
    Pagination,
    SearchAgentsEsimProduct,
    ImportAgentsEsimProduct: () => import('@/views/agents_esim_products/import/index'),
    EditAgentsEsimProduct: () => import('@/views/agents_esim_products/Edit'),
    UpdateAgentsEsimProductEffective: () => import('@/views/agents_esim_products/UpdateEffective'),
    OperationHistoryListModal: () => import('@/views/operation_histories/Modal')
  },
  data() {
    return {
      data: [],
      columns: [
        { title: '产品名称', dataIndex: 'name', width: 180 },
        { title: 'SGP规范', dataIndex: 'sgp_spec_names', width: 180 },
        { title: '有效性', dataIndex: 'effective', width: 100 },
        { title: '创建时间', dataIndex: 'created_at', width: 170 },
        { title: '操作', width: 100, dataIndex: 'actions', scopedSlots: { customRender: 'actions' }}
      ],
      loading: true,
      selectedRowKeys: [],
      isShowImportModal: false,
      isShowEditModal: false,
      isShowOperationHistoryModal: false,
      showingOperationHistoryId: 0,
      editingId: 0,
      pagination: { total_count: 0 },
      query: { effective: '1' }
    }
  },
  computed: {
    agentId() {
      return parseInt(this.$route.params.id)
    },
    isHasEditPermission() {
      return hasPermission('agents_esim_products/edit')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showImportModal() {
      this.isShowImportModal = true
    },
    showEditModal(id) {
      this.editingId = id
      this.isShowEditModal = true
    },
    showOperationHistoryModal(id) {
      this.showingOperationHistoryId = id
      this.isShowOperationHistoryModal = true
    },
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, { per_page: this.query.per_page }, search)
      this.selectedRowKeys = []
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      findAgentsEsimProducts(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
